import { combineReducers } from 'redux';
import userInfoReducer from './user';

const rootReducer = combineReducers({
    user: userInfoReducer,
});

export default rootReducer;